import { Badge, Button } from '@commenda/kakashi';

import { StackedDataPoint } from '../../../components';

interface IndirectTaxTransactionCustomerSectionProps {
  customerName?: string;
  customerEmail?: string;
  onViewCustomer?: () => void;
}

const IndirectTaxTransactionCustomerSection = ({
  customerName,
  customerEmail,
  onViewCustomer,
}: IndirectTaxTransactionCustomerSectionProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-3xl py-lg">
        <span className="txt-small-bold text-text-primary">Customer</span>
        <Button variant="brand-link" size="sm" onClick={onViewCustomer}>
          View customer
        </Button>
      </div>

      <StackedDataPoint label="Name" value={customerName} />
      <StackedDataPoint label="Email" value={customerEmail} />
    </div>
  );
};

export { IndirectTaxTransactionCustomerSection };
